import { useQuery } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import UserDataService from "../../services/user-data-service/UserDataService";
import { IRecipient } from "../../common/models/IRecipient";

export type UseUserRecipientsParameters = {
    groupID: number;
    userID: number;
} & BaseUseQueryParameters<IRecipient[]>;

export function useUserRecipients({
    groupID,
    userID,
    enabled,
    onError,
    onSuccess
}: UseUserRecipientsParameters) {
    return useQuery<IRecipient[], RestError>(
        keys.userRecipients(groupID, userID),
        ({ signal }) => {
            return UserDataService.getUserRecipients(groupID, userID, signal);
        },
        {
            enabled,
            onError,
            onSuccess,
            staleTime: 0
        }
    );
}
